import type { AppAction } from 'actions/types/ActionTypes'
import { trackClientEvent } from 'analytics/analytics'
import { isHotelSightEnabled, type HotelSightOutcome } from 'lib/metasearch/hotelSight'
import { checkHotelSight, type CheckHotelSightInput } from 'lib/metasearch/hotelSightApi'
import { isMetasearchPublicRateActive } from 'lib/metasearch/metasearchPublicRate'

/**
 * Asks svc-order whether to withhold the GHA discount from the signed-in member, and logs the answer.
 * Only reports it; `settleGhaDiscount` acts on it. Never rejects.
 *
 * Resolves `undefined` without asking when the check is switched off, or when the session is already
 * public-rate only: the retry after the price-change modal has nothing left to decide.
 */
export function runHotelSightCheck(input: CheckHotelSightInput): AppAction {
  return async(_dispatch, getState): Promise<HotelSightOutcome | undefined> => {
    if (!isHotelSightEnabled() || isMetasearchPublicRateActive(getState().marketing.metasearchPublicRateMarkedAt)) {
      return undefined
    }
    const outcome = await checkHotelSight(input)
    trackClientEvent({
      subject: 'gha_hotel_sight',
      action: outcome,
      category: 'metasearch',
      type: 'operational',
    })
    return outcome
  }
}
